import 'js/common.js'
import Vue from 'vue'
import Register from 'component/sign/Register.vue'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI);

import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer);

new Vue({
    el: '#app',
    render: h => h(Register)
})


// WEBPACK FOOTER //
// ./src/entry/sign/register.js